export default __webpack_public_path__ + "static/screen-testing-fc505126c9f5a59a5af066f89431e6fb.png";